export default function findActiveWorkspace<
  T extends {
    id: string;
    type: 'PUBLIC' | 'PRIVATE';
  },
>(workspaces: T[]): T {
  return workspaces.sort((a) => (a.type === 'PUBLIC' ? -1 : 1))[0];
}
